import type { IScope } from "angular";
import { cloneDeep, isEmpty, isEqual } from "lodash";
import type { IResponseWithLoading, ISite } from "App/Modules/Models";
import type { IGuardCompany } from "App/Modules/Models/Models/IGuardCompany";
import type { ISitesRepository } from "App/Modules/Repositories";
import type { IFormContainerResolve } from "App/Modules/Services";
import { extendWithLoadingAndFail } from "App/Modules/Services/ObservableExtensions";

export default class EditGuardCompaniesComponentController {
    public static $inject: string[] = ["$scope", "mmSitesRepository"];

    public MAX_GUARD_COMPANIES = 3;

    public site: ISite;

    public resolve: IFormContainerResolve<IGuardCompany[], ISite>;

    public editResponse: IResponseWithLoading<ISite>;

    public guardCompanies: IGuardCompany[];

    public originalGuardCompanies: IGuardCompany[];

    constructor(private readonly $scope: IScope, private readonly sitesRepository: ISitesRepository) {}

    public $onInit() {
        this.site = this.resolve.bindings;
        this.originalGuardCompanies = this.resolve.formData;
        this.guardCompanies = cloneDeep(this.originalGuardCompanies);
    }

    public deleteGuardCompany(index: number) {
        this.guardCompanies.splice(index, 1);
    }

    public addGuardCompany() {
        this.guardCompanies.push({
            name: "",
            phoneNumber: "",
            siteCode: "",
        } as IGuardCompany);
    }

    public editGuardCompanies() {
        const patchObject = {} as ISite;

        if (!isEqual(this.originalGuardCompanies, this.guardCompanies)) {
            patchObject.guardCompanies = this.guardCompanies;
        }

        if (!isEmpty(patchObject)) {
            extendWithLoadingAndFail(this.sitesRepository.patchSite(this.site.id, patchObject)).subscribe(
                (response: IResponseWithLoading<ISite>) => {
                    this.editResponse = response;

                    if (!response.isLoading && response.data) {
                        this.resolve.options.onOk(response.data.guardCompanies);
                    }
                },
                (errorResponse) => {
                    this.editResponse = errorResponse;
                },
            );
        } else {
            this.cancel();
        }
    }

    public cancel() {
        if (this.resolve.options.onCancel) {
            this.resolve.options.onCancel();
        }
    }
}
